import React from 'react';
import { useProgress } from '@react-three/drei';
import { Box, Typography, LinearProgress, Button } from '@mui/material';

function LoadingIndicator({ onRetry }) {
  const { active, progress, errors } = useProgress();

  if (!active && errors.length === 0) return null;

  if (errors.length > 0) {
    return (
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 10,
          textAlign: 'center',
          backgroundColor: 'rgba(0,0,0,0.85)',
          borderRadius: 2,
          padding: 4,
          minWidth: 300,
        }}
      >
        <Typography variant="h6" sx={{ color: '#ff6b6b', marginBottom: 2 }}>
          Failed to load 3D model
        </Typography>
        <Typography variant="body2" sx={{ color: '#ccc', marginBottom: 2 }}>
          {errors[0] || 'An error occurred while loading the model.'}
        </Typography>
        {onRetry && (
          <Button variant="contained" onClick={onRetry} sx={{ marginTop: 1 }}>
            Retry
          </Button>
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 10,
        textAlign: 'center',
        backgroundColor: 'rgba(0,0,0,0.85)',
        borderRadius: 2,
        padding: 4,
        minWidth: 300,
      }}
    >
      <Typography variant="body1" sx={{ color: '#fff', marginBottom: 2, fontWeight: 600 }}>
        Loading 3D Model
      </Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 8,
          borderRadius: 4,
          backgroundColor: 'rgba(255,255,255,0.15)',
          '& .MuiLinearProgress-bar': {
            borderRadius: 4,
            background: 'linear-gradient(90deg, #008CD7, #00C9FF)',
          },
        }}
      />
      <Typography variant="body2" sx={{ color: '#aaa', marginTop: 1 }}>
        {Math.round(progress)}%
      </Typography>
    </Box>
  );
}

export default React.memo(LoadingIndicator);
